var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.907,
    height: 23,
    viewBox: "0 0 22.907 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53275",
    "data-name": "Rectangle 53275",
    width: 22.907,
    height: 23,
    fill: "#80838e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146951",
    "data-name": "Group 146951",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50311",
    "data-name": "Path 50311",
    d: "M22.215,9.307a3.876,3.876,0,0,1-.789-.707,3.643,3.643,0,0,1,.224-1.1,3.049,3.049,0,0,0-.038-2.7,3.036,3.036,0,0,0-2.56-.873,3.736,3.736,0,0,1-1.093-.118,3.734,3.734,0,0,1-.444-1C17.222,1.978,16.859.94,15.885.622a2.952,2.952,0,0,0-2.541.793,3.555,3.555,0,0,1-1,.564,3.551,3.551,0,0,1-1-.564A2.956,2.956,0,0,0,8.805.622C7.832.94,7.468,1.978,7.176,2.813a3.809,3.809,0,0,1-.439.994,3.653,3.653,0,0,1-1.1.121,3.036,3.036,0,0,0-2.56.873,3.051,3.051,0,0,0-.038,2.7,3.746,3.746,0,0,1,.226,1.1,3.74,3.74,0,0,1-.792.714c-.706.54-1.584,1.213-1.584,2.255s.878,1.714,1.584,2.255a3.872,3.872,0,0,1,.789.707,3.643,3.643,0,0,1-.224,1.1,3.05,3.05,0,0,0,.038,2.7,3.037,3.037,0,0,0,2.56.873,3.736,3.736,0,0,1,1.093.118,3.736,3.736,0,0,1,.444,1c.292.835.656,1.874,1.63,2.191a1.709,1.709,0,0,0,.535.086,3.771,3.771,0,0,0,2.006-.878,3.554,3.554,0,0,1,1-.564,3.552,3.552,0,0,1,1,.564,2.956,2.956,0,0,0,2.541.793c.974-.318,1.337-1.356,1.629-2.191a3.809,3.809,0,0,1,.439-.994,3.653,3.653,0,0,1,1.1-.121,3.036,3.036,0,0,0,2.56-.873,3.051,3.051,0,0,0,.038-2.7,3.746,3.746,0,0,1-.226-1.1,3.743,3.743,0,0,1,.792-.714c.705-.54,1.584-1.213,1.584-2.254s-.878-1.714-1.584-2.255ZM16.6,9.844l-4.772,4.792a.952.952,0,0,1-1.349,0h0l-2.386-2.4a.956.956,0,0,1,1.333-1.372l.017.017L11.152,12.6l4.1-4.114a.956.956,0,1,1,1.367,1.338Z",
    transform: "translate(-0.891 -0.062)",
    fill: "#80838e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.6cf55078161e5f260ccf4efd65b287a5.svg";
export { ForwardRef as ReactComponent };